/* 무료보험 프로모션 추가부분 */
import React from 'react'
import classNames from 'classnames/bind'

import Style from './InsuranceLayout.module.scss'

const cx = classNames.bind(Style)

type Props = {
  children?: React.ReactNode
}

const InsuranceLayout = ({ children }: Props) => {
  return <div className={cx('article')}>{children}</div>
}

export default InsuranceLayout
